import capitalize from 'lodash/capitalize';

import { ScreenReaderOnly } from 'approot/shared/styles/global.styles';
import * as Styled from './vocabulary-view-lexical.style';
import { LanguageCodes } from 'global/constants';

type Props = {
  lexical: string;
  description: string;
  languageTag: LanguageCodes | undefined;
};

const VocabularyViewLexical = ({
  lexical,
  description,
  languageTag,
}: Props) => {
  return (
    <Styled.VocabularyLexicalContainer $lexical={lexical}>
      <ScreenReaderOnly as="h2">Lexical Category</ScreenReaderOnly>
      <Styled.VocabularyLexical $lexical={lexical}>
        {capitalize(lexical)}
      </Styled.VocabularyLexical>
      <ScreenReaderOnly as="h2">Description</ScreenReaderOnly>
      <Styled.VocabularyLexicalText lang={languageTag}>
        {description}
      </Styled.VocabularyLexicalText>
    </Styled.VocabularyLexicalContainer>
  );
};

export default VocabularyViewLexical;
